<template>
  <div class="edit-sns-select-box">
    <div class="common-select">
      <select
        :value="value"
        @input="updateValue($event.target.value)"
      >
        <option v-for="option in options" :key="option.value" :value="option.value">
          {{ option.text }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'value',
  ],
  computed: {
    options () {
      return [
        { text: 'X', value: 'X' },
        { text: 'Facebook', value: 'Facebook' },
        { text: 'YouTube', value: 'YouTube' },
        { text: 'Instagram', value: 'Instagram' },
        { text: 'LINE', value: 'LINE' },
        { text: 'Email', value: 'Email' },
        { text: 'Website', value: 'Website' },
        { text: 'Tel', value: 'Tel' }
      ]
    }
  },
  methods: {
    updateValue (value) {
      this.$emit('updateValue', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-sns-select-box {
  position: relative;
  height: 39px;
  .common-select {
    width: 180px;
  }
}
</style>
